import { useTranslation } from "react-i18next";
import useViewDataObject from "../../../hooks/redux/useViewDataObject";
import { VIEW_TYPES } from "../../../config/view/types";
import React, { useCallback } from "react";
import { getContentManagementDataById } from "../../../axios/api/services";
import { BlockText, CONTENT_MANAGEMENT_ID } from "@duosoftbg/nacid-components";
import { Grid } from "@mui/material";
import PageWrapper from "../../components/common/layout/PageWrapper";
import ViewPageWrapper from "./ViewPageWrapper";

const Contacts = () => {
  const { t } = useTranslation();

  const viewType = VIEW_TYPES.CONTACTS;
  const { object, data: contacts } = useViewDataObject(viewType);
  const serviceFn = useCallback(getContentManagementDataById(CONTENT_MANAGEMENT_ID.CONTACTS), []);

  return (
    <PageWrapper title={t("t.page.contacts")}>
      <ViewPageWrapper viewType={viewType} serviceFn={serviceFn} object={object}>
        {contacts && (
          <Grid container rowSpacing={3}>
            <BlockText withGrid label={"l.detail.address"} text={contacts.address} />
            <BlockText withGrid label={"l.detail.infoCenter"} text={contacts.infoCenter} />
            <BlockText withGrid label={"l.detail.telephone"} text={contacts.telephone} />
            <BlockText withGrid label={"l.detail.fax"} text={contacts.fax} />
            <BlockText withGrid label={"l.detail.email"} text={contacts.email} />
            <BlockText withGrid label={"l.detail.website"} text={contacts.website} />
          </Grid>
        )}
      </ViewPageWrapper>
    </PageWrapper>
  );
};

export default Contacts;
